import create from "zustand";

export const useSilentPass = create((set) => ({
  purchaseTimestamp: 0,
  setPurchaseTimestamp: (timestamp: any) =>
    set({ purchaseTimestamp: timestamp }),
}));
